
import React, { useState, useEffect, useContext } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/clinicianSidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";

import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
// import SideMenu from "./student/SideMenu";
import SideMenu from "./student/SideMenu";

// import Sidebar from "../components/dashboard/sidebar";
import SessionPopup from "../pages/SessionPopup";
import Loader from "../components/loader";

let { lambda, appname } = window.app

const ManageTest = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const { search } = state || {};
    const caseTypeFilter = new URLSearchParams(location.search).get("type");
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    // const [sortDirection, setSortDirection] = useState('asc');
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    let id = localStorage.getItem("userId");
    const userType = (localStorage.getItem("userType") || "").toLowerCase().trim();

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity, isRestricted } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);
    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [

        // {
        //     name: 'S No',
        //     selector: row => row?.sno ?? "",
        //     sortable: true,
        // },

        {
            name: 'Path Ref No',
            selector: row => row?.pathrefno ?? "",
            sortable: true,
        },


        {
            name: 'Biopsy Date',
            selector: row => row?.biopsydate,
            sortable: true,
            cell: (props) => props?.created ? dateFormat(props?.biopsydate) : "",
        },

        // {
        //     name: 'Clinic Registration Number',
        //     selector: row => row?.clinicregistrationnumber ?? "",
        //     sortable: true,
        //  },

        {
            name: 'Specimen Type',
            selector: row => row?.specimentype ?? "",
            sortable: true,
        },

        {
            name: 'Site of Biopsy',
            selector: row => row?.siteofbiopsy ?? "",
            sortable: true,
        },

        {
            name: 'Clinical History',
            selector: row => row?.clinicalhistory ?? "",
            sortable: true,
        },
        {
            name: 'Created on',
            selector: row => row?.created,
            sortable: true,
            cell: (props) => props?.created ? dateFormat(props?.created) : "",
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
            cell: (props) => {
                const status = props?.status || "Submitted";
                const statusStyles = {
                    "Draft":                      { background: "#6c757d" },
                    "Submitted":                  { background: "#0d6efd" },
                    "Under Lab Review":           { background: "#0dcaf0", color: "#000" },
                    "Assigned to Pathologist":    { background: "#ffc107", color: "#000" },
                    "Additional Test Requested":  { background: "#fd7e14" },
                    "Additional Test In Progress":{ background: "#6f42c1" },
                    "Reassigned to Pathologist":  { background: "#20c997", color: "#000" },
                    "Completed":                  { background: "#198754" },
                    "Converted to Learning Case": { background: "#0a58ca" },
                };
                const style = statusStyles[status] || { background: "#6c757d" };
                return (
                    <span style={{
                        ...style,
                        color: style.color || "#fff",
                        padding: "3px 8px",
                        borderRadius: "4px",
                        fontSize: "11px",
                        fontWeight: "600",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                    }}>
                        {status}
                    </span>
                );
            },
        },
        ...(userType === "admin" ? [{
            name: 'Case Type',
            selector: row => row?.caseType ?? "Biopsy",
            sortable: true,
            cell: (props) => {
                const ct = props?.caseType || "Biopsy";
                const style = ct === "Learning Case"
                    ? { background: "#198754", color: "#fff" }
                    : { background: "#0d6efd", color: "#fff" };
                return (
                    <span style={{ ...style, padding: "3px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", whiteSpace: "nowrap", display: "inline-block" }}>
                        {ct}
                    </span>
                );
            },
        }] : []),
        {
            name: 'Actions',
            cell: (props) =>
                //   {

                <div className="d-flex">

                    <a onClick={(e) => handleViewUser(e, props.patientid)}
                        className='text-success action-button'><i
                            className="mdi mdi-eye font-size-18"></i>  </a>

                    <a onClick={(e) => handleEditUser(e, props.patientid)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-pencil font-size-18"></i> </a>

                    <a onClick={(e) => handleDeleteUser(e, props.patientid)}
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-delete font-size-18"></i> </a>



                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const dateFormat = (created) => {

        const dateObj = new Date(created);

        // Extract date parts in IST
        const day = dateObj.toLocaleString('en-GB', { day: '2-digit', timeZone: 'Asia/Kolkata' });
        const month = dateObj.toLocaleString('en-GB', { month: '2-digit', timeZone: 'Asia/Kolkata' });
        const year = dateObj.toLocaleString('en-GB', { year: 'numeric', timeZone: 'Asia/Kolkata' });

        // Extract time parts in IST with AM/PM
        const time = dateObj.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata'
        });

        // Combine date and time
        const formattedDateTime = `${day}-${month}-${year} ${time}`;
        return formattedDateTime.toUpperCase();
    }
    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };


    useEffect(() => {
        setRoute("user")
        // setActiveMenuId(200003)
        setData([])
        // userActivity();
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };

    }


    useEffect(() => {
        if (searchedFlag) {
            handleSearch();
        } else {
            User();
        }

    }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    const LAB_TECH_STATUSES = ["Submitted", "Additional Test Requested"];
    const PATHOLOGIST_STATUSES = ["Assigned to Pathologist", "Reassigned to Pathologist"];

    const filterByRole = (rows) => {
        if (!rows) return [];
        let filtered = rows;
        if (userType === "lab technician") {
            filtered = rows.filter(r => LAB_TECH_STATUSES.includes(r?.status));
        } else if (userType === "pathologist") {
            filtered = rows.filter(r =>
                PATHOLOGIST_STATUSES.includes(r?.status) && r?.assignedPathologist === id
            );
        }
        if (caseTypeFilter === "learning") {
            filtered = filtered.filter(r => r?.caseType === "Learning Case");
        }
        return filtered;
    };

    const User = (e) => {
        setIsLoading(true)
        const token = localStorage.getItem("token")
        let listUrl = lambda + '/biopsyCaseInfo?appname=' + appname + "&token=" + token;
        if (userType === "doctor") {
            listUrl += "&createdby=" + id;
        }
        axios({
            method: 'GET',
            url: listUrl,
        })
            .then(function (response) {
                console.log("response", response);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    const filtered = filterByRole(response?.data?.result);
                    setUser(filtered);
                    setData(filtered);
                    global.exportExcelData = filtered



                    setIsLoading(false);
                    setUserSearch("");
                    setSearchedFlag(false);
                }
            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }





    const handleSearch = (e, flagggg) => {
        GetTimeActivity()
        if (flagggg) {
            setcurrentPage(1);
        }
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);
        if (flagggg === "normalsearch") {
            setSearchedFlag(true)
        }
        setFlag(true)
        if (usersearch === "") {
            User();
        }
        else {
            setIsLoading(true)
            const token = localStorage.getItem("token")
            let searchUrl = lambda + '/biopsyCaseInfo?appname=' + appname + "&search=" + usersearch + "&token=" + token;
            if (userType === "doctor") {
                searchUrl += "&createdby=" + id;
            }
            axios({
                method: 'GET',
                url: searchUrl,
            })
                .then(function (response) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        const filtered = filterByRole(response?.data?.result);
                        setUser(filtered);
                        setData(filtered ?? []);
                        global.exportExcelData = filtered



                        setIsLoading(false)
                    }
                }).catch((err) => {
                    console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };
    const handleAddUser = (e) => {
        navigate("/biopsy/cases/new");
    }

    const handleEditUser = (e, paramuserid) => {
        navigate("/biopsy/cases/" + paramuserid + "/edit");
    }

    const handleDeleteUser = (e, paramuserid) => {
        setDeleteUserId(paramuserid)
        setDeleteShow(true)
    }

    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }

    const onDeletePopupClose = (e) => {
        setDeleteSuccess(false)
        setDeleteUserId(null)
        User()
    }

    const handleDelete = async (e) => {
        setDeleteShow(false)
        try {
            await tmdbApi.biopsyCaseDelete(deleteUserId);

            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
    }


    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()

        navigate("/biopsy/cases/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        User();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data were found</p>
                </div> </div>
        )
    }
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.name ?? "",
            "USER TYPE": each?.userType ?? "",
            "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "STATUS": each?.status ?? "",

        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        console.log('data22222--->', data)
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />


                {/* Start right Content here  */}

                <div className="main-content user-management" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">Biopsy</h4>
                                        </div>

                                        <div>
                                            {(userType === "doctor" || userType === "admin") && (
                                                <button className="create-quiz-btn border-0" onClick={handleAddUser} id="add-user-btn">
                                                    {userType === "doctor" ? "Create New Case" : "ADD"}
                                                </button>
                                            )}
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                              {isLoading ? <Loader /> : <>
                                            <div className="row mb-2" id="table-header-row">
                                                <div className="col-sm-4 button-block" id="button-block">
                                                    <div className="dataTables_length" id="datatable-length">

                                                        {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                          onClick={handleExport} id="export-btn">
                          <span className="material-icons">north_east</span>Export
                      </button> */}


                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block" id="search-box">
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={usersearch}
                                                                onChange={(e) => handleChange(e)}
                                                                placeholder="Search"
                                                                onKeyPress={handleKeypress}
                                                                id="search-input"
                                                            />
                                                            <button
                                                                className="fill_btn"
                                                                onClick={(e) => handleSearch(e, "normalsearch")}
                                                                id="search-btn">
                                                                <span className="material-icons search-icon">search</span>
                                                            </button>
                                                        </div>
                                                        <div className="dataTables_length" id="datatable-length-reset">
                                                            <button
                                                                className="fill_btn"
                                                                onClick={clearSearch}
                                                                id="reset-btn">
                                                                <span className="material-icons-outlined">sync</span>Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="text-sm-end" id="text-end"></div>
                                                </div>
                                            </div>

                                            <DataTable
                                                key={keyForRerender}
                                                columns={columns}
                                                keyField='_id'
                                                data={data}
                                                direction="auto"
                                                highlightOnHover
                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                persistTableHead
                                                striped
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={data?.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}
                                                progressPending={isLoading}
                                                progressComponent={<Loader />}
                                                id="data-table"
                                            />
</>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>


                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => onDeletePopupClose(e)}
                    >
                    </SweetAlert>


                    <Footer id="footer" />
                </div>




            </div>
        </>
    );
};

export default ManageTest;
